import React, { FC, useState } from 'react';

import { SearchViewModel } from '@api/index';
import { BookerSearchViewModel } from '@components/views/landing/components/booker/common/BookerSearchDrawer';
import { LocationAnimationErrorBox } from '@components/views/components/listing/ListingStyle';
import { TourTypes } from '@domain/tour/tourAutoComplate';

import ResponsiveListingSearchLocation from './ResponsiveListingSearchLocation';

interface IMobileTourSelection {
  label: string;
  onChange?: (data: SearchViewModel) => void;
  history?: TourTypes[];
  clearPastTourSearch?: () => void;
  removePastTourSearch?: (item: TourTypes) => void;
  isLocationError: boolean;
  setIsLocationError: (value: boolean) => void;
  activeLocation?: TourTypes;
}

const MobileTourSelection: FC<IMobileTourSelection> = ({
  activeLocation,
  onChange,
  history,
  clearPastTourSearch,
  removePastTourSearch,
  isLocationError,
  setIsLocationError,
}) => {
  const [isShowSearchListingLocation, setIsSHowSearchListingLocation] =
    useState(false);
  const [inputLocation, setInputLocation] = useState<string>(
    activeLocation?.text || ''
  );
  const [openAutoCompleteResult, setOpenAutoCompleteResult] =
    useState<boolean>(false);

  /**
   * Handling Clicking on the apply button
   */
  const applySearchLocationHandler = (
    currentSelectedLocation: BookerSearchViewModel
  ) => {
    if (!currentSelectedLocation?.text) {
      setIsLocationError(true);
      return;
    }

    setInputLocation(currentSelectedLocation?.text || '');
    setIsSHowSearchListingLocation(false);
    onChange?.(currentSelectedLocation as SearchViewModel);
    isLocationError && setIsLocationError(false);
  };

  /**
   * Handling Clicking on close location search icon
   */
  const handleCloseLocationSearch = () => {
    setIsSHowSearchListingLocation(false);
    setOpenAutoCompleteResult(false);
  };

  /**
   * Handling Clicking on the location search icon
   */
  const handleOpenLocationSearch = () => {
    setIsSHowSearchListingLocation(true);
  };

  return (
    <LocationAnimationErrorBox hasError={isLocationError || false}>
      <ResponsiveListingSearchLocation
        type='hotel'
        showLocationModal={handleOpenLocationSearch}
        width='100%'
        height='100%'
        placement='top'
        title='Tur / Konum Arama'
        open={isShowSearchListingLocation}
        locationInput={inputLocation}
        locationInputError={isLocationError}
        handleUpdateButton={applySearchLocationHandler}
        handleCloseLocationSearch={handleCloseLocationSearch}
        openAutoCompleteResultModal={openAutoCompleteResult}
        setOpenAutoCompleteResultModal={setOpenAutoCompleteResult}
        pastSearchesData={history}
        onRemoveItem={removePastTourSearch}
        onClearClick={clearPastTourSearch}
        error={isLocationError}
      />
    </LocationAnimationErrorBox>
  );
};

export default MobileTourSelection;
